import React from 'react'
import { type RunContextItem, type RunContextItemOf, type RunContextKind } from '../../../store/customWorkflow/customWorkflows'
import { CONTEXT_KINDS, isKnownKind } from './contextKinds'
import { ContextLabel } from './renderers'

export interface RunContextItemLinkProps {
  item: RunContextItem
  accountId: string
}

const renderKnownKind = <K extends RunContextKind>(item: RunContextItemOf<K>, accountId: string): React.ReactElement => {
  const { Renderer } = CONTEXT_KINDS[item.kind]
  return <Renderer item={item} accountId={accountId} />
}

export const RunContextItemLink: React.FC<RunContextItemLinkProps> = ({ item, accountId }) => {
  if (!isKnownKind(item.kind)) return <ContextLabel item={item} accountId={accountId} />
  return renderKnownKind(item, accountId)
}
